import { render } from "./ErrorMessageCard.vue?vue&type=template&id=77c4a385&scoped=true"
import script from "./ErrorMessageCard.vue?vue&type=script&lang=js"
export * from "./ErrorMessageCard.vue?vue&type=script&lang=js"

import "./ErrorMessageCard.vue?vue&type=style&index=0&id=77c4a385&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c4a385"]])

export default __exports__